(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-article"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bb-article').forEach(function (root) {
    /* in this post: built from the h2s in the body, highlights the one in view */
    var toc = root.querySelector('[data-bb-toc]');
    var prose = root.querySelector('[data-bb-prose]');
    if (toc && prose) {
      var heads = Array.prototype.slice.call(prose.querySelectorAll('h2'));
      if (heads.length >= 2) {
        var list = toc.querySelector('[data-bb-toc-list]');
        var links = heads.map(function (h, i) {
          if (!h.id) h.id = 'section-' + (i + 1) + '-' + (h.textContent || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 40);
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          li.appendChild(a);
          list.appendChild(li);
          return a;
        });
        toc.hidden = false;
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              var i = heads.indexOf(e.target);
              links.forEach(function (a, j) { a.classList.toggle('bb-on', i === j); });
            });
          }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
          heads.forEach(function (h) { io.observe(h); });
        }
      }
    }
    /* copy link */
    root.querySelectorAll('[data-bb-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-bb-copy');
        var done = function () { b.classList.add('bb-on'); setTimeout(function () { b.classList.remove('bb-on'); }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done);
        else done();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-editorial-strip"] && !Shopify.designMode) return;
  try {
    
  /* scroll-linked drift: progress 0..1 while the strip crosses the viewport; row 1 moves left,
     row 2 moves right, by `drift` px at most. Tracks are doubled in Liquid so there is always
     image under the drift. Runs on the Horizon page-wrapper scroll as well as the window. */
  document.querySelectorAll('[data-bb-edit]').forEach(function (sec) {
    if (sec.dataset.bbEditReady) return;
    sec.dataset.bbEditReady = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var drift = parseFloat(sec.dataset.bbEditDrift) || 220;
    var rows = Array.prototype.slice.call(sec.querySelectorAll('[data-bb-edit-track]'));
    var ticking = false;
    function update() {
      ticking = false;
      var r = sec.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      /* 0 when the strip's top enters at the bottom of the screen, 1 when its bottom leaves the top */
      var p = (vh - r.top) / (vh + r.height);
      p = Math.max(0, Math.min(1, p));
      var x = (p - 0.5) * 2 * drift; /* -drift .. +drift, centred when the strip is mid-screen */
      rows.forEach(function (t, i) {
        t.style.setProperty('--bb-edit-x', (i === 0 ? -x : x).toFixed(1) + 'px');
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-featured-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bb-fp').forEach(function (sec) {
    if (sec.dataset.bbFpReady) return;
    sec.dataset.bbFpReady = '1';
    var prev = sec.querySelector('[data-bb-fp-prev]');
    var next = sec.querySelector('[data-bb-fp-next]');
    if (!prev || !next) return;

    /* With category tabs there is one track per pane, so the track is resolved on every
       call rather than captured once: whichever pane is not hidden owns the arrows. */
    function track() {
      var pane = sec.querySelector('[data-bb-fp-pane]:not([hidden])');
      return (pane || sec).querySelector('[data-bb-fp-track]');
    }

    function step(t) {
      var card = t.querySelector('.bb-fp__card');
      if (!card) return t.clientWidth;
      var gap = parseFloat(getComputedStyle(t).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function update() {
      var t = track();
      if (!t) { prev.parentElement.hidden = true; return; }
      var max = t.scrollWidth - t.clientWidth - 2;
      prev.disabled = t.scrollLeft <= 2;
      next.disabled = t.scrollLeft >= max;
      /* nothing to slide (all cards fit): no arrows at all */
      prev.parentElement.hidden = max <= 2;
    }
    /* keep our own target index so quick double clicks advance two cards, not one and a half */
    var target = null;
    function go(dir) {
      var t = track();
      if (!t) return;
      var st = step(t);
      var cur = target === null ? Math.round(t.scrollLeft / st) : target;
      var max = Math.round((t.scrollWidth - t.clientWidth) / st);
      target = Math.max(0, Math.min(max, cur + dir));
      animateTo(t, target * st);
    }
    /* own easing instead of behavior:'smooth': native smooth scrolls are skipped in some
       browsers while the window is unfocused, and snap can cancel them mid-way */
    var raf = null;
    function animateTo(t, to) {
      if (raf) cancelAnimationFrame(raf);
      var from = t.scrollLeft;
      var dist = to - from;
      if (!dist) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || document.hidden) { t.scrollLeft = to; return; }
      var t0 = performance.now();
      var dur = 420;
      t.style.scrollSnapType = 'none';
      function tick(now) {
        var p = Math.min(1, (now - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        t.scrollLeft = from + dist * e;
        if (p < 1) { raf = requestAnimationFrame(tick); }
        else { raf = null; t.style.scrollSnapType = ''; }
      }
      raf = requestAnimationFrame(tick);
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    /* scroll state is per track, so the listeners go on the section and filter by target */
    var ticking = false;
    sec.addEventListener('scroll', function (e) {
      if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-bb-fp-track')) return;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, true);
    sec.addEventListener('scrollend', function () { target = null; }, true);
    sec.addEventListener('touchstart', function () { target = null; }, { passive: true, capture: true });
    window.addEventListener('resize', update);

    /* ---------- category tabs ---------- */
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-bb-fp-tab]'));
    var all = sec.querySelector('[data-bb-fp-all]');

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var pane = document.getElementById(t.getAttribute('aria-controls'));
        if (!pane) return;
        pane.hidden = !on;
        /* The incoming cards have never been scrolled into view, so their entrance
           animation never fired and they would arrive at opacity 0. Reveal them outright
           rather than waiting on the observer: the person clicked the tab, they want the
           products, not a fade. */
        if (on) {
          pane.querySelectorAll('[data-bb-reveal]:not(.bb-on), [data-bb-stagger]:not(.bb-on)')
            .forEach(function (el) { el.classList.add('bb-on'); });
        }
      });
      if (all) {
        var url = tab.getAttribute('data-bb-fp-url');
        var label = tab.getAttribute('data-bb-fp-label');
        if (url) all.href = url;
        if (label) all.textContent = label;
      }
      target = null;
      update();
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        select(tabs[(i + d + tabs.length) % tabs.length], true);
      });
    });

    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-footer"] && !Shopify.designMode) return;
  try {
    
  /* footer wordmark: play the reveal once the strip is (almost) fully on screen, reset when it leaves.
     Horizon scrolls the .page-wrapper on desktop and the window on phones, so instead of relying on
     scroll events we sample the strip's position every frame (one getBoundingClientRect, negligible). */
  (function () {
    var mark = document.querySelector('[data-bb-mark]');
    if (!mark) return;
    var on = false;
    function update() {
      var r = mark.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (!vh || !r.height) return;
      var visible = (vh - r.top) / r.height;   /* 0 = top edge at the fold, 1 = fully on screen */
      if (!on && visible >= 0.92) {
        on = true;
        mark.classList.add('bb-on');
      } else if (on && visible < 0.35) {
        on = false;
        mark.classList.remove('bb-on');
      }
    }
    function loop() {
      update();
      window.requestAnimationFrame(loop);
    }
    update();
    if (window.requestAnimationFrame) window.requestAnimationFrame(loop);
    setInterval(update, 250);
    window.addEventListener('load', update);
  })();

  /* footer menus: open columns on desktop, collapsed accordions on phones */
  (function () {
    var cols = document.querySelectorAll('[data-bb-fcol]');
    if (!cols.length) return;
    var mq = window.matchMedia('(max-width: 900px)');
    function apply() {
      cols.forEach(function (d) { d.open = !mq.matches; });
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else mq.addListener(apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-vote"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bb-vote__form').forEach(function (form) {
    var body = form.querySelector('[data-bb-vote-body]');
    form.querySelectorAll('[data-bb-vote-opt]').forEach(function (r) {
      r.addEventListener('change', function () { if (body) body.value = 'Vote: ' + r.value; });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
